<div class="cart-alliance content-without-footer d-flex position-relative">
    <app-sprintpay-confirmation class="position-absolute" [disabledButton]="isLoading">
        <ng-container body>
            <div class="d-flex flex-wrap justify-content-center mt-3">
                <div class="confirmation-card-info px-4 py-2 m-1 me-md-2">
                    <div class="d-flex my-auto">
                        <h2 class="mat-subtitle-1 confirmation-card-title">
                            Schedule your reservation by clicking the following link:
                            <a class="confirmation-card-info-text" href="https://cargosprintpass.com/" target="_blank">
                                www.cargosprintpass.com
                            </a>
                        </h2>
                    </div>
                </div>
                <div class="confirmation-card-info px-4 py-2 m-1 me-md-2">
                    <h2 class="mat-subtitle-1 confirmation-card-title">
                        Is your trucker new to making reservations? Send them the information they need to get started!
                    </h2>
                    <form [formGroup]="emailForm">
                        <div class="email-form-group row">
                            <mat-form-field class="col-12">
                                <mat-label for="email" class="label-lg text-nowrap">
                                    Enter recipient’s email here
                                </mat-label>
                                <input matInput type="text" id="email" formControlName="email" />
                                <mat-error>
                                    <app-field-error
                                        [field]="'email'"
                                        [messageList]="formErrors['email']"
                                    ></app-field-error>
                                </mat-error>
                                @if (!isLoading) {
                                    <button
                                        mat-button
                                        matSuffix
                                        type="button"
                                        color="primary"
                                        (click)="sendEmail()"
                                        class="ms-3"
                                    >
                                        Send
                                    </button>
                                }
                                @if (isLoading) {
                                    <mat-icon matIconSuffix>
                                        <mat-spinner diameter="24"></mat-spinner>
                                    </mat-icon>
                                }
                            </mat-form-field>
                        </div>
                    </form>
                </div>
            </div>
        </ng-container>
    </app-sprintpay-confirmation>
</div>
